import { PartnersPage } from './PartnersPage.ts';

export const partnersRouter = {
  '/@/creator/partners': PartnersPage, // TODO: path 를 적어주세요.
};
